(ns manage.adset-decision-tree-page.tree-generation-ocp.value-mapping
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Card$default" :as Card]
            ["@mui/material/CardActionArea$default" :as CardActionArea]
            ["@mui/material/CardContent$default" :as CardContent]
            ["@mui/material/Collapse$default" :as Collapse]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/List$default" :as List]
            ["@mui/material/ListItem$default" :as ListItem]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Typography$default" :as Typography]
            ["react-hook-form" :as rhf]
            ["src/svg/inform/cross.svg$default" :as Cross]
            ["src/svg/wpp/content-actions/edit.svg$default" :as Edit]
            [cljs-bean.core :refer [->clj]]
            [common.form :as form]
            [common.util :refer [spread-obj]]
            [manage.adset-decision-tree-page.tree-generation-ocp.hook :as h]
            [manage.adset-decision-tree-page.view.common
             :refer [meta-adset-autocomplete-editor node-icon]]
            [manage.adset-decision-tree-page.view.navigation-panel
             :refer [use-ad-group-summary]]
            [manage.adset-decision-tree-page.view.predicate-editor.core
             :refer [predicate-editor-form]]
            [manage.adset-decision-tree-page.view.side-panel.feed.core
             :refer [feed-properties]]
            [manage.adset-decision-tree-page.view.side-panel.property-form
             :refer [get-property-field-name]]
            [manage.adset-decision-tree-page.view.side-panel.util
             :refer [grey-container-sx]]
            [uix.core :as uix :refer [$ defui]]))

(defui ^:memo column-select
  [{:keys [set-selected-column selected-column classified-columns]}]
  ($ List {:sx #js {:width "30%"}
           :disablePadding true}
     (for [{:keys [label icon column-name] :as column} classified-columns]
       ($ ListItem {:disablePadding true
                    :key column-name}
          ($ Card {:sx #js {:mb 1
                            :width "100%"
                            :borderColor (if (= selected-column column)
                                           "primary.main"
                                           "rgba(0,0,0,0)")
                            :borderStyle "solid"
                            :borderWidth 2}
                   :onClick #(set-selected-column column)}
             ($ CardActionArea
                ($ CardContent
                   ($ Stack {:direction "row"
                             :spacing 2}
                      ($ node-icon {:icon icon})
                      ($ Stack {:spacing 1}
                         ($ Typography label)
                         ($ Typography {:color "text.secondary"} (name column-name)))))))))))

(defui label-predicate-editor
  [{:keys [form-control property]}]
  (let [field-array (form/use-field-array #js {:control (:control form-control)
                                               :name (get-property-field-name property)})]
    ($ predicate-editor-form {:form-control form-control
                              :field-array field-array
                              :property property})))

(defui label-meta-adset-id-editor
  [{:keys [form-control property]}]
  ($ meta-adset-autocomplete-editor
     {:name (get-property-field-name property)
      :placeholder "Select Meta adset ID"
      :control (:control form-control)}))

(defui feed-configuration [{:keys [form-control property]}]
  ($ feed-properties {:form-control form-control
                      :property (dissoc property :has-save-button)
                      :feed-select-type :autocomplete
                      :sx (spread-obj grey-container-sx
                                      #js {:width "100%"
                                           :height "fit-content"})}))

(defui ^:memo predicate-summary [props]
  (let [summary (h/use-predicate-summary props)]
    (or summary "Not configured yet")))

(defui adset-id-summary [{:keys [mapping-value]}]
  (let [{:keys [label description]} (use-ad-group-summary mapping-value)]
    (if mapping-value (str label ": " description) "Not configured yet")))

(defui summary [{:keys [column-property-id field-name control property]}]
  (let [summary-component (case column-property-id
                            :targeting/predicate predicate-summary
                            :meta.facebook/adset-id adset-id-summary)
        mapping-value (rhf/useWatch #js {:name field-name :control control})]
    ($ summary-component {:mapping-value (->clj mapping-value)
                          :property property})))

(defui label-configuration-item-contents
  [{:keys [form-control field-name expanded set-column-expansion property children]
    {:keys [category column-value] column-property-id :id} :property}]
  (case category
    :decision-node children
    :outcome-node
    ($ Stack {:spacing 1
              :sx #js {:width "100%"
                       :p 1}}
       ($ Stack {:direction "row"
                 :justifyContent "space-between"}
          ($ Stack {:spacing 1}
             ($ Typography column-value)
             ($ Typography {:color "text.secondary"}
                (if expanded
                  "Configuring"
                  ($ summary {:control (:control form-control)
                              :field-name field-name
                              :column-property-id column-property-id
                              :property property}))))
          ($ IconButton {:onClick #(set-column-expansion field-name (not expanded))
                         :sx #js {:alignSelf "flex-start"}}
             ($ SvgIcon {:component (if expanded Cross Edit)})))
       ($ Collapse {:in expanded}
          children)
       (when expanded
         ($ Button {:sx #js {:alignSelf "flex-end"}
                    :onClick #(set-column-expansion field-name false)}
            "Done")))))

(defui ^:memo label-configuration-item
  [{:keys [form-control property] :as props}]
  (let [configuration-component (case (:id property)
                                  :targeting/predicate label-predicate-editor
                                  :meta.facebook/adset-id label-meta-adset-id-editor
                                  :feed/properties feed-configuration)]

    ($ ListItem {:sx grey-container-sx}
       ($ label-configuration-item-contents props
          ($ configuration-component {:form-control form-control
                                      :property property})))))

(defui label-configuration
  [{:keys [form-control selected-column classified-columns]}]
  (let [column-name->properties (h/use-column-name->properties classified-columns)
        {:keys [set-column-expansion is-column-expanded]} (h/use-expanded-state)]
    ($ List {:sx #js {:overflowY "auto"
                      :width "100%"}}
       (for [property (get column-name->properties (:column-name selected-column))
             :let [field-name (get-property-field-name property)
                   expanded (is-column-expanded field-name)]]
         ($ label-configuration-item {:key field-name
                                      :expanded expanded
                                      :set-column-expansion set-column-expansion
                                      :property property
                                      :field-name field-name
                                      :form-control form-control})))))

(defui ^:memo value-mapping
  [{:keys [value-mapping-form-control classified-columns selected-column set-selected-column]
    :as props}]
  (uix/use-effect #(set-selected-column (first classified-columns))
                  [set-selected-column classified-columns])
  ($ Stack {:direction "row"
            :spacing 2
            :sx #js {:height "100%"}}
     ($ column-select props)
     ($ Divider {:orientation "vertical" :flexItem true})
     ($ label-configuration
        {:selected-column selected-column
         :form-control value-mapping-form-control
         :classified-columns classified-columns})))
